import type { IconData } from '@stacksjs/iconify-core'

export const gm4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGjTmg8cPS\"><path fill-opacity=\".7\" d=\"M0-48h640v480H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGjTmg8cPS)\" transform=\"translate(0 48)\"><path fill=\"red\" d=\"M0-128h640V85.3H0z\"/><path fill=\"#fff\" d=\"M0 85.3h640V121H0z\"/><path fill=\"#009\" d=\"M0 120.9h640V263H0z\"/><path fill=\"#fff\" d=\"M0 263.1h640v35.6H0z\"/><path fill=\"#090\" d=\"M0 298.7h640V512H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gm4x3
